import React from 'react';
import { Clock, Plus, Pencil, Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

export function OpeningHoursSection({ openingHours, onAdd, onEdit, onDelete }) {
    return (
        <div className="space-y-6" data-testid="welcome-hours">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Opening Hours</h2>
                    <p className="text-muted-foreground text-sm mt-1">
                        Venue and facility operating hours
                    </p>
                </div>
                <Button onClick={onAdd} className="bg-teal-600 hover:bg-teal-700" data-testid="add-hours-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Venue
                </Button>
            </div>

            <div className="space-y-3">
                {openingHours.map((hours) => (
                    <div key={hours.id} className="card-base" data-testid={`hours-card-${hours.id}`}>
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-lg bg-amber-100 flex items-center justify-center flex-shrink-0">
                                <Clock className="w-6 h-6 text-amber-600" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="font-semibold">{hours.venue}</h3>
                                <div className="flex flex-wrap gap-4 mt-1 text-sm">
                                    <span className="text-muted-foreground">
                                        <strong>Weekdays:</strong> {hours.weekday_hours || 'N/A'}
                                    </span>
                                    <span className="text-muted-foreground">
                                        <strong>Weekends:</strong> {hours.weekend_hours || 'N/A'}
                                    </span>
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <Button variant="ghost" size="sm" onClick={() => onEdit(hours)} data-testid={`edit-hours-${hours.id}`}>
                                    <Pencil className="w-4 h-4" />
                                </Button>
                                <Button variant="ghost" size="sm" className="text-red-600 hover:text-red-700 hover:bg-red-50" onClick={() => onDelete(hours)} data-testid={`delete-hours-${hours.id}`}>
                                    <Trash2 className="w-4 h-4" />
                                </Button>
                            </div>
                        </div>
                    </div>
                ))}
                {openingHours.length === 0 && (
                    <div className="text-center py-12 text-muted-foreground">
                        <Clock className="w-12 h-12 mx-auto mb-3 opacity-50" />
                        <p>No opening hours configured. Default hours will be shown.</p>
                        <Button onClick={onAdd} className="mt-4" variant="outline">
                            <Plus className="w-4 h-4 mr-2" />
                            Add Your First Venue
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default OpeningHoursSection;
